function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".experiment_svg__cls-1{fill:#9d9d9c}.experiment_svg__cls-3{fill:#fff}.experiment_svg__cls-4{fill:#ef7e29}.experiment_svg__cls-5{fill:#2888a3}.experiment_svg__cls-6{fill:#fbdd17}.experiment_svg__cls-7{fill:#54a1b6}"));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-1",
  d: "M109.79 70a13.22 13.22 0 00-13.44-13 14 14 0 00-4.37.71V57a13 13 0 00-9.74-12.46 12.72 12.72 0 004.26-9.46 13.22 13.22 0 00-13.44-13A13.38 13.38 0 0060.2 31.5a14.1 14.1 0 00-3.28-.4 13.21 13.21 0 00-13.44 13 12.61 12.61 0 001 4.8c-6.64.7-11.79 5.5-11.79 11.34 0 4.22 2.7 7.9 6.71 9.88a12.17 12.17 0 00-3.4 8.27 12.8 12.8 0 006.44 10.79 15 15 0 00-.82 4.82 15.3 15.3 0 1029.63-5.33 13.56 13.56 0 008-3.94C81.61 93.23 90 107 96.35 107a13.22 13.22 0 0013.44-13 13 13 0 00-8.32-12 13 13 0 008.32-12zm-27.06 7.8a11.88 11.88 0 00.18-2 12.6 12.6 0 00-1.57-6.09A14.67 14.67 0 0083 69.3v.71a12.69 12.69 0 003.52 8.74 27.94 27.94 0 00-3.79-.94z",
  transform: "translate(-4.77 -6.98)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M101.78 69.29a11 11 0 00-11.19-10.8 11.76 11.76 0 00-3.64.59v-.59a10.86 10.86 0 00-8.11-10.38 10.6 10.6 0 003.55-7.88 11 11 0 00-11.2-10.8 11.14 11.14 0 00-10.74 7.79 11.73 11.73 0 00-2.73-.34 11 11 0 00-11.2 10.8 10.33 10.33 0 00.81 4c-5.54.57-9.83 4.58-9.83 9.44a9.38 9.38 0 005.59 8.23 10.13 10.13 0 00-2.82 6.92 10.65 10.65 0 005.36 9 12.74 12.74 0 1024-.43 11.26 11.26 0 006.65-3.29c2 7.1 9 18.54 14.26 18.54a11 11 0 0011.19-10.81 10.81 10.81 0 00-6.92-10 10.81 10.81 0 006.97-9.99zm-22.53 6.5a11.26 11.26 0 00.14-1.66 10.43 10.43 0 00-1.31-5.07 10.32 10.32 0 001.35-.36v.59a10.54 10.54 0 002.94 7.28 21.74 21.74 0 00-3.12-.78z",
  transform: "translate(-4.77 -6.98)",
  fill: "#ededed"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-1",
  d: "M45.85 17.48a11.74 11.74 0 00-11.18 7.87 15 15 0 00-3.38-.35 14.31 14.31 0 00-14.56 14 14.19 14.19 0 0011.58 13.76 15.77 15.77 0 0111.82-6.9A14.42 14.42 0 0139 40.29a15.3 15.3 0 0115.57-15 15.54 15.54 0 012.57.24 11.79 11.79 0 00-11.29-8.05zM114.67 49.68a14.18 14.18 0 00.49-3.15 13.19 13.19 0 00-26-3.82 14.86 14.86 0 016.07 11.37 13.69 13.69 0 015.28-.85A14.41 14.41 0 01114 68.42a14.57 14.57 0 01-.33 2.41 11.23 11.23 0 001-21.15z",
  transform: "translate(-4.77 -6.98)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M228.88 84.32h-14.54a2.41 2.41 0 000 4.74h1.09v49.69a6.19 6.19 0 0012.37 0V89.06h1.08a2.41 2.41 0 000-4.74z",
  transform: "translate(-4.77 -6.98)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M228.88 83.52h-14.54a3.2 3.2 0 000 6.35h.29v48.88a7 7 0 1014 0V89.87h.28a3.2 3.2 0 000-6.35zm0 4.74H227v50.49a5.39 5.39 0 01-10.77 0V88.26h-1.89c-.63 0-1.17-.72-1.17-1.57s.54-1.57 1.17-1.57h14.54c.64 0 1.18.72 1.18 1.57s-.54 1.57-1.18 1.57z",
  transform: "translate(-4.77 -6.98)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M217.13 138a4.49 4.49 0 109 0v-34.11h-9zM222.26 97.25a1.13 1.13 0 101.13 1.13 1.13 1.13 0 00-1.13-1.13z",
  transform: "translate(-4.77 -6.98)"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M222.26 126.48a1.13 1.13 0 101.13 1.12 1.12 1.12 0 00-1.13-1.12zM220 135.08a.56.56 0 00-.56.57.55.55 0 00.56.56.56.56 0 00.56-.56.57.57 0 00-.56-.57zM221.14 114.06a.57.57 0 00-.57.57.57.57 0 001.13 0 .57.57 0 00-.56-.57z",
  transform: "translate(-4.77 -6.98)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M220.57 89a1.55 1.55 0 101.55 1.55 1.55 1.55 0 00-1.55-1.55zM224.24 79.38a1.44 1.44 0 101.44 1.44 1.44 1.44 0 00-1.44-1.44z",
  transform: "translate(-4.77 -6.98)"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M253.39 84.32h-14.54a2.41 2.41 0 000 4.74h1.09v49.69a6.18 6.18 0 0012.36 0V89.06h1.09a2.41 2.41 0 000-4.74z",
  transform: "translate(-4.77 -6.98)"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M253.39 83.52h-14.54a3.2 3.2 0 000 6.35h.29v48.88a7 7 0 1014 0V89.87h.28a3.2 3.2 0 000-6.35zm0 4.74h-1.89v50.49a5.38 5.38 0 01-10.76 0V88.26h-1.89c-.64 0-1.18-.72-1.18-1.57s.54-1.57 1.18-1.57h14.54c.64 0 1.17.72 1.17 1.57s-.56 1.57-1.17 1.57z",
  transform: "translate(-4.77 -6.98)"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M241.63 138a4.49 4.49 0 109 0v-34.11h-9zM246.77 97.25a1.13 1.13 0 101.13 1.13 1.14 1.14 0 00-1.13-1.13z",
  transform: "translate(-4.77 -6.98)"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M246.77 126.48a1.13 1.13 0 101.13 1.12 1.13 1.13 0 00-1.13-1.12zM244.51 135.08a.57.57 0 00-.56.57.56.56 0 00.56.56.57.57 0 00.57-.56.58.58 0 00-.57-.57zM245.64 114.06a.57.57 0 00-.56.57.56.56 0 101.12 0 .57.57 0 00-.56-.57z",
  transform: "translate(-4.77 -6.98)"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M245.08 89a1.55 1.55 0 101.55 1.55 1.55 1.55 0 00-1.55-1.55zM244.48 73.68a1.13 1.13 0 101.13 1.13 1.12 1.12 0 00-1.13-1.13z",
  transform: "translate(-4.77 -6.98)"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M281 84.32h-14.51a2.41 2.41 0 000 4.74h1.08v49.69a6.19 6.19 0 0012.37 0V89.06H281a2.41 2.41 0 000-4.74z",
  transform: "translate(-4.77 -6.98)"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M281 83.52h-14.51a3.2 3.2 0 000 6.35h.28v48.88a7 7 0 1014 0V89.87h.23a3.2 3.2 0 000-6.35zm0 4.74h-1.89v50.49a5.38 5.38 0 01-10.76 0V88.26h-1.89c-.64 0-1.18-.72-1.18-1.57s.54-1.57 1.18-1.57H281c.64 0 1.17.72 1.17 1.57s-.5 1.57-1.17 1.57z",
  transform: "translate(-4.77 -6.98)"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M269.27 138a4.49 4.49 0 109 0v-34.11h-9zM274.41 97.25a1.13 1.13 0 101.13 1.13 1.13 1.13 0 00-1.13-1.13z",
  transform: "translate(-4.77 -6.98)"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M274.41 126.48a1.13 1.13 0 101.13 1.12 1.12 1.12 0 00-1.13-1.12zM272.15 135.08a.58.58 0 00-.57.57.57.57 0 00.57.56.56.56 0 00.56-.56.57.57 0 00-.56-.57zM273.28 114.06a.57.57 0 00-.57.57.57.57 0 001.13 0 .57.57 0 00-.56-.57z",
  transform: "translate(-4.77 -6.98)"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M272.71 89a1.55 1.55 0 101.56 1.55 1.54 1.54 0 00-1.56-1.55zM277.09 69.18a1.55 1.55 0 101.56 1.55 1.54 1.54 0 00-1.56-1.55zM271.84 78.6a1.56 1.56 0 101.55 1.55 1.55 1.55 0 00-1.55-1.55zM276.38 79.38a1.44 1.44 0 101.44 1.44 1.44 1.44 0 00-1.44-1.44zM272.71 72.24a1.44 1.44 0 101.44 1.44 1.44 1.44 0 00-1.44-1.44zM273.28 62.13a1.44 1.44 0 101.44 1.44 1.44 1.44 0 00-1.44-1.44z",
  transform: "translate(-4.77 -6.98)"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M94.28 82.43a3.5 3.5 0 000-7H68.53a3.5 3.5 0 000 7h3.32l-21.94 72.75a4 4 0 004 4h55a4 4 0 004-4L91 82.43z",
  transform: "translate(-4.77 -6.98)"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M94.28 83.32a4.39 4.39 0 100-8.77H68.53a4.39 4.39 0 000 8.77h2.13l-21.6 71.61v.25a4.89 4.89 0 004.89 4.89h55a4.9 4.9 0 004.89-4.89L92.16 83.32zm17.74 72a3.13 3.13 0 01-3.11 3h-55a3.12 3.12 0 01-3.11-3l22.25-73.77h-4.52a2.62 2.62 0 010-5.23h25.75a2.62 2.62 0 110 5.23h-4.51z",
  transform: "translate(-4.77 -6.98)"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M78.73 104.78A2.26 2.26 0 1081 107a2.26 2.26 0 00-2.27-2.22zM83.51 94.49a1.6 1.6 0 101.59 1.6 1.6 1.6 0 00-1.59-1.6zM80.5 83.91a1.6 1.6 0 000 3.19 1.6 1.6 0 100-3.19z",
  transform: "translate(-4.77 -6.98)"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M21.74 190.99h95.16v3.55H21.74z"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-7",
  d: "M62.93 106.95l-2.15 6.75H92.5l-2.14-6.75H62.93z"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M65.55 120.68l-9.64 30.24a3.15 3.15 0 003.24 3.08h44.52a3.14 3.14 0 003.23-3.06l-9.63-30.24z",
  transform: "translate(-4.77 -6.98)"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M77.16 134.39a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.5zM90 145.92a1.44 1.44 0 101.44 1.44 1.43 1.43 0 00-1.44-1.44zM81.41 119.57a1.44 1.44 0 101.44 1.43 1.43 1.43 0 00-1.44-1.43zM72.16 126a1.45 1.45 0 101.44 1.45 1.44 1.44 0 00-1.44-1.45zM83.51 138.11a1.44 1.44 0 101.49 1.44 1.43 1.43 0 00-1.49-1.44zM94.42 128.51a1.45 1.45 0 101.44 1.49 1.44 1.44 0 00-1.44-1.49zM76.47 146.87a1.44 1.44 0 101.44 1.44 1.44 1.44 0 00-1.44-1.44zM83.51 127.46A2.5 2.5 0 1086 130a2.49 2.49 0 00-2.49-2.54z",
  transform: "translate(-4.77 -6.98)"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M83.65 54.73a2.29 2.29 0 00-2.36 2.2L81 74.55h5V56.93a2.29 2.29 0 00-2.35-2.2zM92 58.41c-1.4-1.4-3.2-1.87-4-1s-.36 2.62 1 4l64.16 61-1.66-9.41z",
  transform: "translate(-4.77 -6.98)"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M83.65 54.73c-1.67.07-2.36 8-2.36 8L86 66.9s-1.53-11 7.61-.79l.3-5.69s-4.71-5.9-10.26-5.69zM218.44 71.28c0 3.14 1.1 3.68 2.7 3.68s2.69-.52 2.69-3.66-2.69-7.73-2.69-7.73-2.7 4.57-2.7 7.71z",
  transform: "translate(-4.77 -6.98)"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M243.05 76.25c0 2 .59 2.35 1.43 2.35s1.42-.33 1.42-2.34a14.72 14.72 0 00-1.42-4.94 14.56 14.56 0 00-1.43 4.93z",
  transform: "translate(-4.77 -6.98)"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M313 53.3l-15.7 30.55a2.61 2.61 0 002.7 2.53h36.76a2.61 2.61 0 002.68-2.53L323.7 53.3z",
  transform: "translate(-4.77 -6.98)"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M309.44 13.42h8.26a1.23 1.23 0 011.23 1.23V78a1.22 1.22 0 01-1.22 1.22h-8.27a1.22 1.22 0 01-1.22-1.22V14.65a1.23 1.23 0 011.23-1.23z"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M325.15 20.4h-13.62a1.21 1.21 0 00-1.22 1.22v1.53a1.22 1.22 0 001.22 1.23h13.62a1.23 1.23 0 001.23-1.23v-1.53a1.22 1.22 0 00-1.23-1.22z",
  transform: "translate(-4.77 -6.98)"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M316.67 27h-2.78a.52.52 0 000 1h2.78a.52.52 0 000-1zM316.67 32.46h-2.78a.52.52 0 000 1h2.78a.52.52 0 000-1zM316.67 38.06h-2.78a.5.5 0 00-.46.52.49.49 0 00.46.52h2.78a.49.49 0 00.46-.52.5.5 0 00-.46-.52zM316.67 43.05h-2.78a.5.5 0 00-.46.52.49.49 0 00.46.52h2.78a.49.49 0 00.46-.52.5.5 0 00-.46-.52zM316.67 48.49h-2.78a.49.49 0 00-.46.52.5.5 0 00.46.52h2.78a.5.5 0 00.46-.52.49.49 0 00-.46-.52z",
  transform: "translate(-4.77 -6.98)"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M318.34 7h-44.58a.86.86 0 00-.63.26.89.89 0 00-.26.63l.33 36.18h-78.28a.88.88 0 00-.88.89l-.3 130h-23.83a.89.89 0 100 1.77h24.72a.87.87 0 00.88-.88l.3-130h77.4V54a.89.89 0 001.79 0v-9l-.34-36.18h42.8V24a.89.89 0 001.78 0V7.87a.89.89 0 00-.9-.87zM364.51 37.18H323.7a.89.89 0 100 1.77h39.93v48.68a.89.89 0 101.77 0V38.06a.88.88 0 00-.89-.88z",
  transform: "translate(-4.77 -6.98)"
});
var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M67.73 44.83c10.17.41 8.74 29.72 8.74 29.72h8S83 53 77.86 48.38c-6.28-5.64-10.13-3.55-10.13-3.55z",
  transform: "translate(-4.77 -6.98)"
});
var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M68.23 30.66a2.91 2.91 0 00-3.15 2.59v1.92H12.29a7.53 7.53 0 000 15h52.79v1.92a3.2 3.2 0 006.28 0V33.25a2.9 2.9 0 00-3.13-2.59z",
  transform: "translate(-4.77 -6.98)"
});
var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-7",
  d: "M71.7 69.34l-.92 37.61h10.89l-1.94-37.61H71.7z"
});
var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M314.39 58.53L302.8 81.07a1.92 1.92 0 002 1.86h27.13a1.91 1.91 0 002-1.86l-11.64-22.54z",
  transform: "translate(-4.77 -6.98)"
});
var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M163 155.9V137h.83a1.86 1.86 0 000-3.65h-11.2a1.86 1.86 0 000 3.65h.84v18.9a18.52 18.52 0 00-13.65 16h36.81a18.53 18.53 0 00-13.63-16z",
  transform: "translate(-4.77 -6.98)"
});
var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M163.86 155.23v-17.36a2.74 2.74 0 00-.05-5.43h-11.18a2.74 2.74 0 000 5.43v17.36a19.45 19.45 0 00-13.64 16.56l-.1 1h38.77l-.1-1a19.46 19.46 0 00-13.7-16.56zm-23 15.77a17.67 17.67 0 0112.87-14.24l.66-.18v-20.49h-1.73c-.29 0-.63-.38-.63-.94s.34-.93.63-.93h11.18c.3 0 .63.38.63.93s-.33.94-.63.94h-1.72v20.49l.66.18A17.68 17.68 0 01175.62 171z",
  transform: "translate(-4.77 -6.98)"
});
var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M139.82 171.89c-.06.61-.11 1.24-.11 1.88a18.51 18.51 0 0037 0c0-.64 0-1.27-.1-1.88z",
  transform: "translate(-4.77 -6.98)"
});
var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M173.35 170.84l-4-1-3.64 1-3.52-1-3.65 1-4.23-1-3 1-4.17-1-3.84 1-4.09-1s-.61 3.59-.61 4.2a19.41 19.41 0 0019.59 19.32c10.79 0 19.55-8.26 19.55-19 0-.87-.48-4.06-.48-4.06zm-15.13 20.39a17.48 17.48 0 01-17.46-17.46v-.85h34.89v.85a17.49 17.49 0 01-17.43 17.46z",
  transform: "translate(-4.77 -6.98)"
});
var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M173 169.23c-.13.16-.33.4-.46.44a2.61 2.61 0 01-.41-.44 3.76 3.76 0 00-6.32 0 1.67 1.67 0 01-.45.44 3.06 3.06 0 01-.42-.44 3.75 3.75 0 00-6.31 0 1.67 1.67 0 01-.45.44 2.61 2.61 0 01-.41-.44 3.75 3.75 0 00-6.31 0 1.81 1.81 0 01-.44.44 2.59 2.59 0 01-.42-.44 3.75 3.75 0 00-6.31 0 1.81 1.81 0 01-.44.44 2.59 2.59 0 01-.42-.44 3.91 3.91 0 00-3.15-1.72v3.55a2.59 2.59 0 01.42.44 3.75 3.75 0 006.31 0 1.81 1.81 0 01.44-.44 2.25 2.25 0 01.42.44 3.75 3.75 0 006.31 0 1.81 1.81 0 01.44-.44 2.61 2.61 0 01.41.44 3.75 3.75 0 006.31 0 1.84 1.84 0 01.46-.44 2.61 2.61 0 01.41.44 3.75 3.75 0 006.31 0c.13-.16.33-.4.46-.44a2.61 2.61 0 01.41.44 3.76 3.76 0 006.32 0c.14-.16.33-.4.44-.44v-3.55a3.93 3.93 0 00-3.15 1.72zM158.22 162a1.3 1.3 0 101.31 1.3 1.3 1.3 0 00-1.31-1.3zM158.48 146a.67.67 0 10.67.67.66.66 0 00-.67-.67zM157.59 139.39a1.54 1.54 0 00-1.55 1.55 1.56 1.56 0 101.55-1.55z",
  transform: "translate(-4.77 -6.98)"
});
var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M156.92 125.09a1.3 1.3 0 101.3 1.3 1.3 1.3 0 00-1.3-1.3zM156.92 129.73a.88.88 0 000 1.75.88.88 0 100-1.75zM160.57 127.69a1.31 1.31 0 101.3 1.3 1.3 1.3 0 00-1.3-1.3zM160.32 121a.67.67 0 10.68.67.67.67 0 00-.68-.67zM154.65 118a.67.67 0 100 1.34.67.67 0 000-1.34zM148.78 176.83a2.78 2.78 0 102.77 2.78 2.78 2.78 0 00-2.77-2.78zM161.87 172.62a2 2 0 102 2 2.05 2.05 0 00-2-2zM161.87 182.93a1.19 1.19 0 101.19 1.19 1.19 1.19 0 00-1.19-1.19zM171.76 174.66a1.2 1.2 0 101.2 1.19 1.19 1.19 0 00-1.2-1.19zM158.54 22.6h-6.44a5.29 5.29 0 00-5.48 5.08v51.24A5.29 5.29 0 00152.1 84h6.44a5.28 5.28 0 005.46-5.08V27.68a5.29 5.29 0 00-5.46-5.08z",
  transform: "translate(-4.77 -6.98)"
});
var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M155.42 69.23a6.24 6.24 0 106.24 6.24 6.24 6.24 0 00-6.24-6.24z",
  transform: "translate(-4.77 -6.98)"
});
var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M152.16 31.82h-4c-.39 0-.7.19-.7.43s.31.43.7.43h4c.39 0 .71-.19.71-.43s-.32-.43-.71-.43zM152.16 38.65h-4c-.39 0-.7.19-.7.43s.31.43.7.43h4c.39 0 .71-.19.71-.43s-.32-.43-.71-.43zM150.54 35.21h-2.63a.43.43 0 100 .85h2.63a.43.43 0 100-.85zM152.16 45h-4c-.39 0-.7.19-.7.43s.31.43.7.43h4c.39 0 .71-.19.71-.43s-.32-.43-.71-.43zM152.16 51.86h-4c-.39 0-.7.19-.7.43s.31.43.7.43h4c.39 0 .71-.19.71-.43s-.32-.43-.71-.43zM150.54 48.42h-2.63a.43.43 0 100 .85h2.63a.43.43 0 100-.85zM150.54 41.83h-2.63a.43.43 0 100 .86h2.63a.43.43 0 100-.86zM152.16 58.7h-4c-.39 0-.7.19-.7.43s.31.43.7.43h4c.39 0 .71-.19.71-.43s-.32-.43-.71-.43zM150.54 55.25h-2.63a.43.43 0 100 .86h2.63a.43.43 0 100-.86zM152.16 65.08h-4c-.39 0-.7.19-.7.42s.31.43.7.43h4c.39 0 .71-.19.71-.43s-.32-.42-.71-.42zM150.54 61.87h-2.63a.45.45 0 00-.46.44.44.44 0 00.46.42h2.63a.45.45 0 00.46-.42.45.45 0 00-.46-.44zM155.42 25.7a1.55 1.55 0 00-1.55 1.56v24.6H157v-24.6a1.56 1.56 0 00-1.58-1.56z",
  transform: "translate(-4.77 -6.98)"
});
var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M153.87 72.41a1.56 1.56 0 103.11 0V51.86h-3.11z",
  transform: "translate(-4.77 -6.98)"
});
var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M213.28 37.96h5.04v10.76h-5.04zM237.79 37.96h5.04v10.76h-5.04zM265.42 37.96h5.04v10.76h-5.04z"
});
var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M98.5 90.16H13.61c-1 0-1.77.54-1.77 1.21v1.06c0 .67.79 1.21 1.77 1.21H98.5c1 0 1.77-.54 1.77-1.21v-1.06c0-.67-.79-1.21-1.77-1.21z",
  transform: "translate(-4.77 -6.98)"
});
var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M29.08 70h-1.42c-.63 0-1.15.85-1.15 1.91v127.54c0 1.06.52 1.91 1.15 1.91h1.42c.64 0 1.15-.85 1.15-1.91V71.91c0-1.06-.51-1.91-1.15-1.91z",
  transform: "translate(-4.77 -6.98)"
});
var _ref49 = /*#__PURE__*/React.createElement("rect", {
  className: "experiment_svg__cls-5",
  x: 16.77,
  y: 77.54,
  width: 13.66,
  height: 13.42,
  rx: 1.77
});
var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M364 84.33a1.45 1.45 0 00-1.5 1.4V97h3.17l-.17-11.23a1.46 1.46 0 00-1.5-1.44zM358.73 86.68l-37.93 34.78-1 5.94 40.87-38.83c.89-.89 1.19-2 .66-2.56s-1.71-.23-2.6.67z",
  transform: "translate(-4.77 -6.98)"
});
var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M364 84.33c-3.54-.13-6.55 3.62-6.55 3.62l-.36 4c5.82-6.5 5.41.16 5.41.16l3-2.68s-.42-5.06-1.5-5.1zM310.65 157.06c0 3.79 1.11 4.44 2.7 4.44s2.68-.63 2.68-4.43-2.68-9.33-2.68-9.33-2.7 5.51-2.7 9.32zM318.39 150c0 3.79 1.11 4.45 2.7 4.45s2.68-.64 2.68-4.43-2.68-9.34-2.68-9.34-2.7 5.52-2.7 9.32z",
  transform: "translate(-4.77 -6.98)"
});
var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M312.33 138.37c0 3.15.92 3.69 2.24 3.69s2.23-.52 2.23-3.67-2.23-7.75-2.23-7.75-2.24 4.58-2.24 7.73z",
  transform: "translate(-4.77 -6.98)"
});
var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M369.87 118V96.66h-10.71V118a20.83 20.83 0 00-15.36 18h41.42a20.81 20.81 0 00-15.35-18z",
  transform: "translate(-4.77 -6.98)"
});
var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M371 117.08V96.66h-2.35v22.2l.87.24a19.7 19.7 0 0114.32 15.68h-38.7a19.73 19.73 0 0114.32-15.68l.88-.24v-22.2H358v20.42a22.08 22.08 0 00-15.36 18.75l-.13 1.29h44l-.12-1.29A22.09 22.09 0 00371 117.08z",
  transform: "translate(-4.77 -6.98)"
});
var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M343.8 136a21.18 21.18 0 00-.12 2.12 20.83 20.83 0 1041.66 0 18.57 18.57 0 00-.12-2.12z",
  transform: "translate(-4.77 -6.98)"
});
var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M386.29 134.78h-4.75l-4.48-1.18-4.1 1.18-4-1.18-4.1 1.18-4.76-1.18-3.38 1.18-4.69-1.18-4.32 1.18h-5l-.11 1.05c-.08.85-.12 1.56-.12 2.24a22 22 0 0044 0c0-.68 0-1.39-.11-2.24zm-21.78 22.94a19.68 19.68 0 01-19.66-19.65v-.95h39.27v.95a19.67 19.67 0 01-19.61 19.65z",
  transform: "translate(-4.77 -6.98)"
});
var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M382.64 133.49c-.52.62-.72.83-1.18.83s-.66-.21-1.19-.83a3.5 3.5 0 00-6 0c-.52.62-.73.83-1.18.83s-.66-.21-1.18-.83a3.5 3.5 0 00-6 0c-.52.62-.73.83-1.18.83s-.66-.21-1.18-.83a3.5 3.5 0 00-6 0c-.52.62-.72.83-1.18.83s-.66-.21-1.18-.83a3.49 3.49 0 00-6 0c-.53.62-.73.83-1.19.83s-.66-.21-1.17-.83a3.75 3.75 0 00-3-1.67v2.34c.45 0 .66.2 1.18.83a3.5 3.5 0 006 0c.52-.63.72-.83 1.18-.83s.66.2 1.18.83a3.49 3.49 0 006 0c.53-.63.74-.83 1.19-.83s.66.2 1.18.83a3.49 3.49 0 006 0c.53-.63.73-.83 1.18-.83s.66.2 1.19.83a3.5 3.5 0 006 0c.51-.63.72-.83 1.18-.83s.66.2 1.18.84a3.51 3.51 0 006 0c.53-.64.73-.84 1.2-.84v-2.34a3.7 3.7 0 00-3.03 1.67zM364.51 124.81a1.47 1.47 0 101.47 1.46 1.47 1.47 0 00-1.47-1.46zM364.66 108.29a.58.58 0 10.57.57.57.57 0 00-.57-.57zM363.9 102.63a1.33 1.33 0 101.33 1.33 1.34 1.34 0 00-1.33-1.33z",
  transform: "translate(-4.77 -6.98)"
});
var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M353.88 141.51a3.13 3.13 0 103.13 3.14 3.13 3.13 0 00-3.13-3.14zM368.61 136.78a2.3 2.3 0 102.3 2.29 2.29 2.29 0 00-2.3-2.29zM368.61 148.37a1.35 1.35 0 101.35 1.35 1.36 1.36 0 00-1.35-1.35z",
  transform: "translate(-4.77 -6.98)"
});
var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M203.65 120.93h78.97v3.81h-78.97zM203.65 140.45h78.97v3.51h-78.97z"
});
var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M203.65 120.93h3.69v23.04h-3.69zM227.35 120.93h3.69v23.04h-3.69zM253.41 120.93h3.69v23.04h-3.69zM278.93 120.93h3.69v23.04h-3.69z"
});
var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M74.6 46.16c-8.6-5.77-48.29-7.28-48.29-7.28-3.49 0-17.52-.13-17.52 3.56 0 1.68 1 4.09 17.72 4.09 0 0 39.07-4.77 46.52 2.4.57.55 2.84-1.93 1.57-2.77z",
  transform: "translate(-4.77 -6.98)"
});
var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M68.23 30.66a2.91 2.91 0 00-3.15 2.59v1.92H12.29a7.53 7.53 0 000 15h52.79v1.92a3.2 3.2 0 006.28 0V33.25a2.9 2.9 0 00-3.13-2.59zm1.36 21.48c0 .37-.59.81-1.36.81s-1.37-.44-1.37-.81v-3.7H12.29a5.75 5.75 0 010-11.5h54.57v-3.69c0-.38.6-.81 1.37-.81s1.36.43 1.36.81z",
  transform: "translate(-4.77 -6.98)"
});
var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M332.21 166.74h-28.69a2.35 2.35 0 000 4.66H305v25.06a4.17 4.17 0 004.17 4.17h17.38a4.17 4.17 0 004.17-4.17V171.4h1.48a2.35 2.35 0 000-4.66z",
  transform: "translate(-4.77 -6.98)"
});
var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M332.21 165.85h-28.69a3.23 3.23 0 000 6.44h.6v24.17a5.06 5.06 0 005.06 5h17.38a5 5 0 005.05-5v-24.17h.6a3.23 3.23 0 000-6.44zm0 4.67h-2.37v25.94a3.28 3.28 0 01-3.28 3.28h-17.38a3.28 3.28 0 01-3.29-3.28v-25.94h-2.37a1.48 1.48 0 010-2.9h28.69a1.48 1.48 0 010 2.9z",
  transform: "translate(-4.77 -6.98)"
});
var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M307.58 194.42a3.34 3.34 0 003.33 3.34h13.91a3.35 3.35 0 003.34-3.34v-14.49h-20.58z",
  transform: "translate(-4.77 -6.98)"
});
var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M314.71 177.86h-8.11a.64.64 0 100 1.27h8.11a.64.64 0 100-1.27zM314.71 184.2h-8.11a.64.64 0 100 1.27h8.11a.64.64 0 100-1.27zM314.71 190.46h-8.11a.64.64 0 00-.64.63.64.64 0 00.64.64h8.11a.64.64 0 00.64-.64.64.64 0 00-.64-.63zM319.54 190.19a1.54 1.54 0 101.54 1.54 1.54 1.54 0 00-1.54-1.54zM319.54 174.87a1 1 0 000 1.95 1 1 0 100-1.95zM314.57 170.62a1.54 1.54 0 101.54 1.53 1.53 1.53 0 00-1.54-1.53zM325.27 183.17a1 1 0 101 1 1 1 0 00-1-1z",
  transform: "translate(-4.77 -6.98)"
});
var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M343.72 154.52h33.72v3.32h-33.72zM353.48 158.72h13.12v3.31h-13.12z"
});
var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-3",
  d: "M358.09 160.3h3.31v32.32h-3.31z"
});
var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M417.39 153.7h1a2.68 2.68 0 000-5.28h-16.2a2.69 2.69 0 000 5.28h1V173s-6.17 6-11.26 10.74v16h36.65v-16C423.57 179 417.39 173 417.39 173z",
  transform: "translate(-4.77 -6.98)",
  fill: "#f6f6f6"
});
var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M419.17 172.23v-16.85a4.32 4.32 0 003.17-4.32 4.21 4.21 0 00-4-4.41h-16.15a4.21 4.21 0 00-4 4.41 4.33 4.33 0 003.17 4.32v16.85c-1.61 1.56-6.54 6.32-10.69 10.2a1.75 1.75 0 00-.56 1.3v16a1.77 1.77 0 001.78 1.76h36.65a1.76 1.76 0 001.77-1.76v-16a1.75 1.75 0 00-.56-1.3c-4.04-3.88-8.97-8.64-10.58-10.2zm9.44 27.51H392v-16C397 179 403.17 173 403.17 173v-19.3h-1a2.69 2.69 0 010-5.28h16.18a2.68 2.68 0 010 5.28h-1V173s6.18 6 11.26 10.74zM404.52 137.82c0 5.42 2.36 6.35 5.77 6.35s5.76-.9 5.76-6.32-5.76-13.34-5.76-13.34-5.77 7.88-5.77 13.31zM416.64 127c0 2.27.66 2.66 1.61 2.66s1.61-.38 1.61-2.65a16.59 16.59 0 00-1.61-5.58 16.5 16.5 0 00-1.61 5.57z",
  transform: "translate(-4.77 -6.98)"
});
var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M406.81 138.71c0 2.65.77 3.11 1.88 3.11s1.88-.44 1.88-3.1-1.88-6.51-1.88-6.51-1.88 3.85-1.88 6.5z",
  transform: "translate(-4.77 -6.98)"
});
var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M409.21 133.76c0 2.66.77 3.11 1.88 3.11s1.87-.44 1.87-3.09-1.87-6.52-1.87-6.52-1.88 3.85-1.88 6.5zM406.81 113.14c0 2.65.77 3.11 1.88 3.11s1.88-.44 1.88-3.1-1.88-6.52-1.88-6.52-1.88 3.86-1.88 6.51z",
  transform: "translate(-4.77 -6.98)"
});
var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M388.83 177.14h32.98v13.61h-32.98z"
});
var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M408 182.2c0 2.65.77 3.1 1.88 3.1s1.88-.44 1.88-3.09-1.88-6.52-1.88-6.52-1.88 3.85-1.88 6.51z",
  transform: "translate(-4.77 -6.98)"
});
var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M410.41 177.24c0 2.66.77 3.11 1.88 3.11s1.87-.44 1.87-3.09-1.87-6.52-1.87-6.52-1.88 3.85-1.88 6.5zM408 156.62c0 2.66.77 3.11 1.88 3.11s1.88-.44 1.88-3.09-1.88-6.52-1.88-6.52-1.88 3.88-1.88 6.5z",
  transform: "translate(-4.77 -6.98)"
});
var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-1",
  d: "M84.35 165.61h-.09a5.37 5.37 0 00-10.18.07c-2.44.35-4.3 2.14-4.3 4.31a4 4 0 001.31 2.89 5.71 5.71 0 00-.2 1.5c0 3.87 3.7 7 8.28 7s8.28-3.14 8.28-7a5.55 5.55 0 00-.09-.83 4.23 4.23 0 002.16-3.55c0-2.42-2.31-4.39-5.17-4.39z",
  transform: "translate(-4.77 -6.98)"
});
var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-6",
  d: "M82.16 172.55a7.37 7.37 0 00.13-4.41c-1.1-4.44-4.66-4.21-4.66-4.21s3.08.27.14 3.34-2.34 5.34-2.34 5.34a8.22 8.22 0 01-1.4-2.4c-2.33 7.6 5.91 10.79 5.91 10.79 9.57-3.17 4.3-12.25 4.3-12.25 0 2.05-2.08 3.8-2.08 3.8z",
  transform: "translate(-4.77 -6.98)"
});
var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M81.14 174.78a4.34 4.34 0 00.07-2.61c-.65-2.62-2.75-2.49-2.75-2.49s1.81.16.08 2-1.38 3.16-1.38 3.16a4.68 4.68 0 01-.83-1.42c-1.38 4.5 3.49 6.37 3.49 6.37 5.66-1.87 2.55-7.24 2.55-7.24a3.51 3.51 0 01-1.23 2.23z",
  transform: "translate(-4.77 -6.98)",
  fill: "#f0fb27"
});
var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-4",
  d: "M71.48 182.68a1.42 1.42 0 000 .2v10.81a1.6 1.6 0 001.61 1.6h13.17a1.6 1.6 0 001.6-1.6v-10.81a1.42 1.42 0 000-.2z",
  transform: "translate(-4.77 -6.98)"
});
var _ref80 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-5",
  d: "M88.23 182.21H71.07l-.06.4a1.18 1.18 0 000 .25v10.81a2.07 2.07 0 002.08 2.07h13.17a2.07 2.07 0 002.07-2.07v-10.79a.72.72 0 000-.27zm-.84 11.48a1.13 1.13 0 01-1.13 1.13H73.05a1.13 1.13 0 01-1.14-1.13v-10.54h15.48z",
  transform: "translate(-4.77 -6.98)"
});
var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "experiment_svg__cls-1",
  d: "M91.46 18.4a4 4 0 104 4 4 4 0 00-4-4zM41.89 111.36a2.58 2.58 0 102.57 2.57 2.58 2.58 0 00-2.57-2.57zM17.74 56.93a2.57 2.57 0 102.57 2.57 2.57 2.57 0 00-2.57-2.57zM124.16 71.11a2.57 2.57 0 102.57 2.57 2.57 2.57 0 00-2.57-2.57z",
  transform: "translate(-4.77 -6.98)"
});
function SvgExperiment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "experiment_svg___\\u017D\\xD3\\u0165_1",
    "data-name": "\\u2014\\u017D\\xD3\\u0165_1",
    viewBox: "0 0 425.66 194.54"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81);
}
export default SvgExperiment;